import { customerApiWithOptionalCode } from './base/api-with-optional-code'

const getSharedCustomerQuarterlyUsage = customerApiWithOptionalCode('quarterly-data')

export default getSharedCustomerQuarterlyUsage